import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { renderToSheetList } from 'fela-dom';
export default function renderToNodeListFactory(createElement) {
  return function renderToNodeList(renderer) {
    var sheetList = renderToSheetList(renderer);
    return sheetList.map(function (_ref) {
      var type = _ref.type,
          media = _ref.media,
          rehydration = _ref.rehydration,
          support = _ref.support,
          css = _ref.css;
      return createElement('style', _extends({
        key: type + media
      }, renderer.styleNodeAttributes, {
        media: media,
        'data-fela-rehydration': rehydration,
        'data-fela-type': type,
        'data-fela-support': support,
        dangerouslySetInnerHTML: {
          __html: css
        }
      }));
    });
  };
}